<div class="margin-all-area">
    <div class="wraper-main-section">
        <div class="global-card-section">
            <!--<div class="global-header-section">
              <div class="svg-icon-panel"><img src="../../../assets/appttitle.svg" class="mr-1" />Lead Next Action</div>
            </div>-->
            <p class="message-info" *ngIf="taskId > 0">{{msg}}</p>
            <form [formGroup]="leadNextActionForm" (ngSubmit)="submitLeadNextAction()">
                <div class="cards-body-section">
                    <div class="cards-colunm-left">
                        <span>Lead Next Action</span>
                    </div>
                    <div class="cards-colunm-right">
                        <textarea class="form-control" *ngIf="!isViewOnlyLeadNextAction" formControlName="nextAction"></textarea>
                        <span *ngIf="isViewOnlyLeadNextAction">{{leadReportNAResponse?.lblNextAction}}</span>
                    </div>
                </div>
                <div class="cards-body-section">
                    <div class="cards-colunm-left">
                        <div style="text-align:right">
                            <span>Due Date</span>
                            <span style="color:green">(format: m/d/yyyy)</span>
                        </div>
                    </div>
                    <div class="cards-colunm-right">
                        <!--<kendo-datepicker formControlName="dueDate" [min]="minDate" [max]="maxDate" [ngClass]="{'has-error': leadNextActionForm.controls.dueDate.errors && (leadNextActionForm.controls.dueDate.touched || leadNextActionForm.controls.dueDate.dirty)}"></kendo-datepicker>-->
                        <div class="custom-mat-cal">
                            <mat-form-field appearance="fill" [ngClass]="{'has-error': leadNextActionForm.controls.dueDate.errors && (leadNextActionForm.controls.dueDate.touched || leadNextActionForm.controls.dueDate.dirty)}">
                                <input matInput [matDatepicker]="dp" formControlName="dueDate" [min]="minDate" [max]="maxDate">
                                <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                                <mat-datepicker #dp></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="login-error" *ngIf="leadNextActionForm.controls.dueDate.errors && (leadNextActionForm.controls.dueDate.touched || leadNextActionForm.controls.dueDate.dirty)">
                            <span *ngIf="leadNextActionForm.controls.dueDate.errors.required">Please enter a date. </span>
                        </div>
                    </div>
                </div>
                <div class="cards-body-section">
                    <div class="cards-colunm-left">
                        <span>Next Action By</span>
                    </div>
                    <div class="cards-colunm-right">
                        <select class="form-control" formControlName="nextActionBy" *ngIf="!isViewOnlyLeadNextAction">
                            <option [value]="item?.id" *ngFor="let item of userList;">{{item?.text}}</option>
                        </select>
                        <span *ngIf="isViewOnlyLeadNextAction">{{leadReportNAResponse?.lblNextActionBy}}</span>
                    </div>
                </div>
                <div class="cards-body-section">
                    <div class="cards-colunm-left">
                        <span>Lead</span>
                    </div>
                    <div *ngIf="!isViewOnlyLeadNextAction" class="cards-colunm-right">
                        {{leadDescription}}
                    </div>
                    <div *ngIf="isViewOnlyLeadNextAction" class="cards-colunm-right">
                        {{leadReportNAResponse?.lblLeadDescription}}
                    </div>
                </div>
                <div class="cards-body-section">
                    <div class="cards-colunm-left">
                        <span>Lead Manager</span>
                    </div>
                    <div *ngIf="!isViewOnlyLeadNextAction" class="cards-colunm-right">
                        {{user?.firstName}} {{user?.lastName}}
                       
                    </div>
                    <div *ngIf="isViewOnlyLeadNextAction" class="cards-colunm-right">
                        {{leadReportNAResponse?.lblLeadManager}}
                    </div>
                </div>
                <div class="global-padding10">
                    <button type="submit" class="btn btn-primary">Save</button>
                    <button type="button" class="btn btn-cancel" (click)="onCancel()">Cancel</button>
                </div>
            </form>
        </div>
    </div>
</div>
